import { useState, useEffect } from 'react'

// Desktop two-pane layout kicks in at/above this width. The LINE LIFF webview
// is always a phone (well below this), so it never takes the desktop branch —
// the mobile experience is guaranteed unchanged.
export const DESKTOP_MIN_WIDTH = 1024

const query = `(min-width: ${DESKTOP_MIN_WIDTH}px)`

const getMatches = () => {
  if (typeof window === 'undefined' || !window.matchMedia) { return false }
  return window.matchMedia(query).matches
}

const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(getMatches)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) { return }
    const mql = window.matchMedia(query)
    const handler = (e) => setIsDesktop(e.matches)
    setIsDesktop(mql.matches)

    if (mql.addEventListener) {
      mql.addEventListener('change', handler)
      return () => mql.removeEventListener('change', handler)
    }
    // Safari < 14 fallback
    mql.addListener(handler)
    return () => mql.removeListener(handler)
  }, [])

  return isDesktop
}

export default useIsDesktop
